import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {loadAccessoriesOrders} from '../../accessories/actions/orders';

const getPartsCodes = (list) => {
  const partsCodes = [];

  list.forEach((item) => {
    const partsList = item.partsList;

    partsList.forEach((part) => {
      const existPartCode = partsCodes.includes(part.partCode);
      if (!existPartCode) {
        partsCodes.push(part.partCode);
      }
    });
  });

  return partsCodes.join();
};

export const fetchStock = (partsCodes) => apiActionCreator({
  'endpoint': `/parts/warehouse-stock?partsCodes=${partsCodes}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_STOCK,
    ActionTypes.FETCHED_STOCK,
    [
      ActionTypes.FETCHED_STOCK_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchSummarySetsOrders = (startDate, endDate, orderWasPlaced) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/accessories/orders/combos/summary?startDate=${startDate}&endDate=${endDate}` +
      `&orderPlaced=${orderWasPlaced}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_SUMMARY_SETS_ORDERS,
        [
          (response) => {
            if (response.data.length > 0 && orderWasPlaced === 'NO') {
              dispatch(fetchStock(getPartsCodes(response.data)));
            }
            return {'type': ActionTypes.FETCHED_SUMMARY_SETS_ORDERS};
          },
        ],
        [
          ActionTypes.FETCHED_SUMMARY_SETS_ORDERS_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const requestOrderToCpd = (data, startDate, endDate, refresh, params) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/orders/dealers/emergent/cpd',
      'authenticated': true,
      'types': [
        ActionTypes.REQUESTING_ORDER_TO_CPD,
        [
          ActionTypes.REQUESTED_ORDER_TO_CPD,
          () => {
            if (refresh) {
              dispatch(fetchSummarySetsOrders(startDate, endDate, 'NO'));
            }
            if (data.origin === 'acc-orders' && params) {
              dispatch(loadAccessoriesOrders(params));
            }
            return {
              'type': ActionTypes.NOTHING,
            };
          },
          (response) => MessageActions.addMessageBoxInfo(`El pedido ${response.data.orderCode} ha sido ` +
            'generado satisfactoriamente'),
        ],
        [
          ActionTypes.REQUESTED_ORDER_TO_CPD_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'POST',
      'contentType': 'application/json',
      'data': data,
    })
  );
};
